module.exports = __webpack_public_path__ + "static/img/advantagebg2.06e71c4f.jpg";